import { Component, Input } from '@angular/core';
import { BackButtonService } from '../back-button.service';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    standalone: false,
})
export class BackButtonComponent {
    @Input()
    public backText = 'Terug';

    constructor(private backButtonService: BackButtonService) {}

    navigateBack(): void {
        this.backButtonService.navigateBack();
    }
}
